import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { fad } from '@awesome.me/kit-b4fd369ea4/icons';
import { PivotColsDialog } from './PivotColsDialog';

export const PivotColsButton = ({ availableCols, groupByCols, amountCols, setPivotCols }) => {
  const { openDialog } = useDialog();

  const openPivotColsDialog = () => {
    openDialog(PivotColsDialog, { availableCols, groupByCols, amountCols }).then((result) => {
      if (!result) return;
      setPivotCols(result);
    });
  };

  return <TitleButton icon={fad.faLayerGroup} toolTip="Configure Pivot" onClick={openPivotColsDialog} />;
};
